import {ScheduleSlot} from "../../entities/server/ScheduleSlot";
import moment from "moment/moment";

export class ScheduleItem {
  id: number;
  relative: string;
  name: string;
  type: string;
  location: string;
  starts: Date;
  ends: Date;
  delayedStart?: Date;
  delayedEnd?: Date;
  cancelled: boolean;

  realStart: Date;
  realEnds: Date;

  private parseDate(input?: string): Date | undefined {
    if (input === undefined || input === null) return undefined;
    const s = String(input).trim();
    if (s.length === 0) return undefined;

    // If numeric-like, treat as epoch milliseconds
    const maybeNum = Number(s.replace(/n$/, ''));
    if (!Number.isNaN(maybeNum) && /^-?\d+n?$/.test(s)) {
      const dn = new Date(maybeNum);
      if (!Number.isNaN(dn.getTime())) return dn;
    }

    // Try native Date parsing of ISO or RFC strings
    const d = new Date(s);
    if (!Number.isNaN(d.getTime())) return d;

    // Last attempt using Date.parse explicitly
    const t = Date.parse(s);
    if (!Number.isNaN(t)) return new Date(t);

    return undefined;
  }

  getStart(): Date {
    return this.delayedStart ?? this.starts;
  }

  getEnds(): Date {
    return this.delayedEnd ?? this.ends;
  }

  isNow(): boolean {
    const now = Date.now();
    const start = this.getStart().getTime();
    const end = this.getEnds().getTime();
    return start < now && end > now;
  }

  ended(): boolean {
    return this.getEnds().getTime() < Date.now();
  }

  constructor(slot: ScheduleSlot) {
    this.id = slot.id;
    this.name = slot.activity.name;

    // Accept both legacy and canonical field names from API
    const startStr = (slot.timeStarts ?? (slot as any).starts) as any;
    const endStr = (slot.timeEnds ?? (slot as any).ends) as any;
    const delayedStartStr = (slot.delayedStart ?? (slot as any).delayed_start ?? (slot as any).delayedStart) as any;
    const delayedEndStr = (slot.delayedEnd ?? (slot as any).delayed_end ?? (slot as any).delayedEnd) as any;

    // Required starts/ends: ensure valid Date instances; fallback to now if parsing fails
    this.starts = this.parseDate(startStr) ?? new Date();
    this.ends = this.parseDate(endStr) ?? new Date();

    // Optional delayed values
    const dStart = this.parseDate(delayedStartStr);
    if (dStart) this.delayedStart = dStart;
    const dEnd = this.parseDate(delayedEndStr);
    if (dEnd) this.delayedEnd = dEnd;

    this.type = slot.activity.type;
    this.location = slot.activity.location;
    this.cancelled = slot.cancelled;

    if (this.isNow() || this.ended())
      this.relative = moment(this.getEnds()).fromNow();
    else
      this.relative = moment(this.getStart()).fromNow();

    this.realStart = this.getStart();
    this.realEnds = this.getEnds();
  }
}
